import type { ImpactCenterMetricsResponse } from "@shared/services/impact-center/getImpactCenterMetrics.ts";

const TOUR_SERVER_NAME = "demo";

export default async (): Promise<ImpactCenterMetricsResponse> => ({
  results: [
    {
      technicalServerName: TOUR_SERVER_NAME,
      aiAssetMetrics: {
        models: { registered: 12 },
        skills: { registered: 4 },
        mcps: { registered: 3 },
        plugins: { registered: 2 },
        shadowAi: { detected: 0, firstSeenInWindow: 0 },
      },
    },
  ],
});
